import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useResize } from '@playbooks/hooks';

export const AppContext = React.createContext(null);

const AppProvider = ({ ssr, children }) => {
	const [layout, setLayout] = useState<any>('');
	const [collapsed, setCollapsed] = useState(false);
	const [size, setSize] = useState({ xxl: null, xl: null, lg: null, md: null, sm: null, xs: null });
	const [sidebarData, setSidebarData] = useState<any>({ workspaceId: null, folders: [] });
	const router = useRouter();

	// Hooks
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [router.pathname]);

	useResize(() => {
		setSize({
			xxl: window.innerWidth > 1536,
			xl: window.innerWidth >= 1280,
			lg: window.innerWidth >= 1024,
			md: window.innerWidth >= 768,
			sm: window.innerWidth >= 640,
			xs: window.innerWidth < 640,
		});
	}, []);

	// Methods
	const onToggle = () => setCollapsed(value => !value);

	// Render
	return (
		<AppContext.Provider
			value={{
				ssr,
				layout,
				setLayout,
				collapsed,
				setCollapsed,
				onToggle,
				size,
				sidebarData,
				setSidebarData,
				children,
			}}>
			{children}
		</AppContext.Provider>
	);
};

const useApp = () => {
	return React.useContext(AppContext);
};

export { AppProvider, useApp };
